import {Component, Input} from '@angular/core';
import {DateUtil} from '../../../../util/DateUtil';
import {HealthDetail} from '../../../../../ent/services/alula-health-cloud.service';

@Component({
  selector: 'app-vivascore-details-overview',
  templateUrl: './vivascore-details-overview.component.html',
  styleUrls: ['./vivascore-details-overview.component.scss']
})
export class VivascoreDetailsOverviewComponent {
  readonly dateFormat: string = DateUtil.dateFormatWithHyphenated;
  @Input() healthData: HealthDetail;
}
